import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.5 6C5.5 6.5628 5.31403 7.08217 5.00018 7.5H6.99982C6.68597 7.08217 6.5 6.5628 6.5 6C6.5 4.61929 7.61929 3.5 9 3.5C10.3807 3.5 11.5 4.61929 11.5 6C11.5 7.38017 10.3816 8.49912 9.00162 8.5L9 8.5L2.99844 8.5C1.61844 8.49916 0.5 7.38019 0.5 6C0.5 4.61929 1.61929 3.5 3 3.5C4.38071 3.5 5.5 4.61929 5.5 6Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.33342 8.00033C7.33342 8.75073 7.08545 9.44322 6.66699 10.0003H9.33317C8.91471 9.44322 8.66675 8.75073 8.66675 8.00033C8.66675 6.15938 10.1591 4.66699 12.0001 4.66699C13.841 4.66699 15.3334 6.15938 15.3334 8.00033C15.3334 9.84056 13.8422 11.3325 12.0022 11.3337L12.0001 11.3337L3.998 11.3337C2.15801 11.3325 0.666748 9.84058 0.666748 8.00033C0.666748 6.15938 2.15913 4.66699 4.00008 4.66699C5.84103 4.66699 7.33342 6.15938 7.33342 8.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.16659 9.99967C9.16659 10.9377 8.85663 11.8033 8.33356 12.4997H11.6663C11.1432 11.8033 10.8333 10.9377 10.8333 9.99967C10.8333 7.69849 12.6987 5.83301 14.9999 5.83301C17.3011 5.83301 19.1666 7.69849 19.1666 9.99967C19.1666 12.3 17.3026 14.1649 15.0026 14.1663L14.9999 14.1663L4.99732 14.1663C2.69733 14.1649 0.833252 12.3 0.833252 9.99967C0.833252 7.69849 2.69873 5.83301 4.99992 5.83301C7.30111 5.83301 9.16659 7.69849 9.16659 9.99967Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 6C4.5 5.17157 3.82843 4.5 3 4.5C2.17157 4.5 1.5 5.17157 1.5 6C1.5 6.82843 2.17157 7.5 3 7.5C3.82843 7.5 4.5 6.82843 4.5 6ZM10.5 6C10.5 5.17157 9.82843 4.5 9 4.5C8.17157 4.5 7.5 5.17157 7.5 6C7.5 6.82843 8.17157 7.5 9 7.5C9.82843 7.5 10.5 6.82843 10.5 6ZM11.5 6C11.5 7.38071 10.3807 8.5 9 8.5H3C1.61929 8.5 0.5 7.38071 0.5 6C0.5 4.61929 1.61929 3.5 3 3.5C4.38071 3.5 5.5 4.61929 5.5 6C5.5 6.56284 5.31388 7.08215 5 7.5H7C6.68612 7.08215 6.5 6.56284 6.5 6C6.5 4.61929 7.61929 3.5 9 3.5C10.3807 3.5 11.5 4.61929 11.5 6Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.00008 8.00033C6.00008 6.89576 5.10465 6.00033 4.00008 6.00033C2.89551 6.00033 2.00008 6.89576 2.00008 8.00033C2.00008 9.1049 2.89551 10.0003 4.00008 10.0003C5.10465 10.0003 6.00008 9.1049 6.00008 8.00033ZM14.0001 8.00033C14.0001 6.89576 13.1047 6.00033 12.0001 6.00033C10.8955 6.00033 10.0001 6.89576 10.0001 8.00033C10.0001 9.1049 10.8955 10.0003 12.0001 10.0003C13.1047 10.0003 14.0001 9.1049 14.0001 8.00033ZM15.3334 8.00033C15.3334 9.84127 13.841 11.3337 12.0001 11.3337H4.00008C2.15913 11.3337 0.666748 9.84127 0.666748 8.00033C0.666748 6.15938 2.15913 4.66699 4.00008 4.66699C5.84103 4.66699 7.33342 6.15938 7.33342 8.00033C7.33342 8.75078 7.08526 9.4432 6.66675 10.0003H9.33342C8.9149 9.4432 8.66675 8.75078 8.66675 8.00033C8.66675 6.15938 10.1591 4.66699 12.0001 4.66699C13.841 4.66699 15.3334 6.15938 15.3334 8.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.49992 9.99967C7.49992 8.61896 6.38063 7.49967 4.99992 7.49967C3.61921 7.49967 2.49992 8.61896 2.49992 9.99967C2.49992 11.3804 3.61921 12.4997 4.99992 12.4997C6.38063 12.4997 7.49992 11.3804 7.49992 9.99967ZM17.4999 9.99967C17.4999 8.61896 16.3806 7.49967 14.9999 7.49967C13.6192 7.49967 12.4999 8.61896 12.4999 9.99967C12.4999 11.3804 13.6192 12.4997 14.9999 12.4997C16.3806 12.4997 17.4999 11.3804 17.4999 9.99967ZM19.1666 9.99967C19.1666 12.3009 17.3011 14.1663 14.9999 14.1663H4.99992C2.69873 14.1663 0.833252 12.3009 0.833252 9.99967C0.833252 7.69849 2.69873 5.83301 4.99992 5.83301C7.30111 5.83301 9.16659 7.69849 9.16659 9.99967C9.16659 10.9377 8.85639 11.8033 8.33325 12.4997H11.6666C11.1434 11.8033 10.8333 10.9377 10.8333 9.99967C10.8333 7.69849 12.6987 5.83301 14.9999 5.83301C17.3011 5.83301 19.1666 7.69849 19.1666 9.99967Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconVoicemail: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"voicemail"} {...props} />
);
